import { FC, useState } from 'react';
import {
  Center,
  Heading,
  VStack,
  Button,
  Box,
  Text,
  Flex,
  Spinner,
} from '@chakra-ui/react';
import { useAdminRelevantActions } from '@olagg/api-hooks';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../../consts/routes';
import { FaPlus } from 'react-icons/fa';
import Pagination from '@olagg/ui-kit/Pagination';
import RelevantActionsTable from './Table';
import { IUseRelevantActions } from '@olagg/api-hooks/interfaces/IUseRelevantActions';
import { OlaggModule, PermissionEnum } from '@olagg/db-types';
import useRoles from '../../features/Roles/hooks/useRoles';

const RelevantActions: FC = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams()
  const [filter, setFilter] = useState<IUseRelevantActions>({
    page: Number(searchParams.get('page') || 1),
    limit: Number(searchParams.get('limit') || 10),
  })
  const { missingPermission } = useRoles();
  
  const onFilter = ({
    name,
    value
  }: { name: string, value: any }) => {
    setFilter({ ...filter, [name]: value })

    if (value) searchParams.set(name, value)
    else searchParams.delete(name)
    setSearchParams(searchParams)
  }

  const { page, limit } = filter;
  const { data, deleteRelevantAction, isLoading } = useAdminRelevantActions(filter);
  const relevantActions = data?.relevantActions;
  const count = data?.meta.count;

  return (
    <Center w='full' pb={4}>
      <VStack color={'white'} w='full'>
        <Heading my={2}>
          Acciones relevantes
        </Heading>

        <Flex w='full' alignItems='center' gap='5'>
          <Button
            mt='2' mb='5'
            display='flex'
            variant="outlinedGradient"
            leftIcon={<FaPlus />}
            onClick={() => navigate(ROUTES.RELEVANT_ACTIONS.create)}
            isDisabled={missingPermission(OlaggModule.RelevantAction, PermissionEnum.EDIT)}
          >
            Agregar Acción
          </Button>
        </Flex>

        {isLoading ? (
          <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600' flexDirection='column'>
            <Spinner />
          </Box>
        ) : (
          relevantActions && relevantActions?.length > 0 ? (
            <RelevantActionsTable 
              relevantActions={relevantActions}
              deleteRelevantAction={deleteRelevantAction}
            />
          ) : (
            <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600' flexDirection='column'>
              <Text>No hay ninguna acción relevante aún</Text>
            </Box>
          )
        )}

        <Pagination
          params={{ limit, page, count }}
          onClick={page =>
            onFilter({
              name: 'page',
              value: String(page + 1)
            } as EventTarget & HTMLInputElement)
          }
          onLimitChange={val =>
            onFilter({
              name: 'limit',
              value: val
            } as EventTarget & HTMLInputElement)
          }
          hideLimitInput
        />
      </VStack>
    </Center >
  )
};

export default RelevantActions;
